export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const img = (src) => {
  if (!src) return src;
  if (src.startsWith("/api/")) return `${BACKEND}${src}`;
  return src;
};

export const FREE_SHIPPING_THRESHOLD = 10000;
export const SHIPPING_FEE = 499;
